export * from './header/header.component';
export * from './tab/tab.component';
export * from './footer/footer.component';
export * from './tiny-mce/tiny-mce.component';
